import type { ReactElement } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useNav } from "./useNav";
import type { Tab } from "./model";

export const slugOf = (path: string) => path.slice(path.lastIndexOf("/") + 1);

/** null = render `tab`; otherwise the path to go to instead. */
export function settingsRedirect(tabs: readonly Tab[], tab: string | undefined, available: readonly string[]): string | null {
  const allowed = tabs.filter((t) => available.includes(slugOf(t.path)));
  if (allowed.length === 0) return "/";
  if (tab && allowed.some((t) => slugOf(t.path) === tab)) return null;
  return allowed[0].path;
}

/** One tabbed Settings page per area (spec §6); the menu registry decides which tabs a person sees. */
export function SettingsPage({ itemId, screens }: { itemId: string; screens: Record<string, ReactElement> }) {
  const { tab } = useParams();
  const { search } = useLocation();
  const { areas } = useNav();
  const item = areas.flatMap((a) => a.groups.flatMap((g) => g.items)).find((i) => i.id === itemId);
  const target = settingsRedirect(item?.tabs ?? [], tab, Object.keys(screens));
  if (target) return <Navigate to={target + search} replace />;
  return screens[tab as string];
}
